import { cleanEmailBodyText } from '../../inbox/utils/cleanEmailContent';

/**
 * Older e-mail communications stored the raw `body_text` (escaped `\r\n`, repeated tracking links):
 * clean it the way the inbox does. Rich-text comments carry no line breaks and pass through unchanged.
 */
export function cleanCommunicationComment(type: string | null, comment: string | null): string | null {
  if (type !== 'email' || !comment) {
    return comment;
  }
  return cleanEmailBodyText(comment);
}
